import React from 'react';

export default function Head() {
  return (
    <section>
      <h1 className="mb-3">Add Internal Coaches</h1>

      <p>
        Create a list of internal coaches from your organization and invite them all at once.
      </p>
    </section>
  );
}
